(() => {
  const initPopup = (root) => {
    if (!root || root.dataset.popupInitialized === 'true') return;

    const trigger = root.querySelector('[data-product-popup-trigger]');
    const dialog = root.querySelector('[data-product-popup-dialog]');
    const closeButton = root.querySelector('[data-product-popup-close]');
    if (!trigger || !dialog) return;

    root.dataset.popupInitialized = 'true';

    if (root.classList.contains('product-highlights-popup')) {
      const body = root.querySelector('.product-highlights-popup__body');
      const firstHeading = body?.querySelector('h1, h2, h3, h4, h5, h6');
      if (firstHeading?.textContent.trim().toLowerCase() === 'product information') firstHeading.remove();
    }

    let closeTimer;

    const openDialog = () => {
      if (typeof dialog.showModal !== 'function' || dialog.open) return;
      window.clearTimeout(closeTimer);
      dialog.classList.remove('is-closing');
      dialog.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-open')));
    };

    const closeDialog = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      dialog.classList.remove('is-open');
      dialog.classList.add('is-closing');
      closeTimer = window.setTimeout(() => {
        dialog.classList.remove('is-closing');
        if (dialog.open) dialog.close();
      }, 320);
    };

    trigger.addEventListener('click', openDialog);
    closeButton?.addEventListener('click', closeDialog);
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-product-popup]').forEach(initPopup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
